import Vue from "vue";
import "./componentHooks";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/scss/main.scss";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "@authentic-labs/vue-component-library/dist/vue-component-library.css";
import VueSmoothScroll from "vue2-smooth-scroll";
import smoothscroll from "smoothscroll-polyfill";

import amplitude from "amplitude-js";

amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE_KEY);

smoothscroll.polyfill();

Vue.use(VueSmoothScroll, {
  duration: 500, // animation duration in ms
  offset: -1000, // offset in px from scroll element, can be positive or negative
  easingFunction: "easeInCubic", // gives the ability to provide a custom easing function `t => ...`
  // (see https://gist.github.com/gre/1650294 for examples)
  // if nothing is given, it will defaults to `easeInOutCubic`
});

// Vue.use(VueVirtualScroller)

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
